(function () {
  'use strict';


  var routes = (window.Shopify && window.routes) || window.routes || {};
  function cartAddUrl() { return (window.routes && window.routes.cart_add_url) || '/cart/add'; }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  
  /* ---------- Quick add (upsells) ---------- */
  if (!customElements.get('dox-quick-add')) {
    customElements.define('dox-quick-add', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.btn = this.form.querySelector('[type="submit"]');
        this.form.addEventListener('submit', (e) => this.onSubmit(e));
      }
      onSubmit(evt) {
        if (!window.fetch) return;
        evt.preventDefault();
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var fd = new FormData(this.form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          fd.append('sections', cart.getSectionsToRender().map((sx) => sx.id).join(','));
          fd.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        if (this.btn) this.btn.classList.add('dox-loading');
        fetch(cartAddUrl(), { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then((r) => r.json())
          .then((res) => {
            if (res.status) { window.location = cartUrl(); return; }
            if (cart && typeof cart.renderContents === 'function') {
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              cart.renderContents(res);
            } else { window.location = cartUrl(); }
          })
          .catch(() => { window.location = cartUrl(); })
          .finally(() => { if (this.btn) this.btn.classList.remove('dox-loading'); });
      }
    });
  }

  
})();
